module.exports = __webpack_public_path__ + "assets/img/img-8.119a72f5.png";